import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { IImportAM, ImportService } from './import-api';

@autoinject
export class ImportList {
	@bindable customerId: string;
	@bindable importStatus: 'staged' | 'archived';

	importEntries: IImportAM[];

	constructor(private importService: ImportService) {
	}

	@computedFrom('importStatus')
	get titleResourceName() : string {
		return this.importStatus === 'staged'
			? 'ImportList_Heading_StagedImports'
			: 'ImportList_Heading_ArchivedImports';
	}

	async customerIdChanged(newValue: string) {
		if (newValue) {
			this.importEntries = await this.importService.getImports(this.importStatus, this.customerId);
		} else {
			this.importEntries = [];
		}
	}
}
